// Define the article source enum to match the database
export const ArticleSource = {
  ZIARUL_FINANCIAR: 'ZIARUL_FINANCIAR',
  BURSA_RO: 'BURSA.RO',
  PROFIT_RO: 'PROFIT.RO',
  ECONOMICA_NET: 'ECONOMICA.NET',
  WALL_STREET: 'WALL_STREET',
  ECONOMEDIA: 'ECONOMEDIA',
} as const;

export type ArticleSource = (typeof ArticleSource)[keyof typeof ArticleSource];
export type ArticleSourceType = keyof typeof ArticleSource;

// Map enum values to display-friendly names
export const getDisplaySourceName = (source: ArticleSource): string => {
  const sourceMap: Record<ArticleSource, string> = {
    ZIARUL_FINANCIAR: 'Ziarul Financiar',
    'BURSA.RO': 'Bursa.ro',
    'PROFIT.RO': 'Profit.ro',
    'ECONOMICA.NET': 'Economica.net',
    WALL_STREET: 'Wall-Street.ro',
    ECONOMEDIA: 'Economedia.ro',
  };
  return sourceMap[source] || source;
};

// Define the base Article type
export type Article = {
  id: number;
  source: string;
  source_name: ArticleSource;
  title: string;
  description: string | null;
  thumbnail_url: string;
  created_at: string;
  time_posted: string;
};

// Define the LlmDetection type
export type LlmDetection = {
  id: number;
  article_id: number;
  identified_symbol: string | null;
  prediction_json: {
    schimbare2lasuta: 'nustiu' | 'sus' | 'jos';
    scor: number;
    sentiment: 'neutru' | 'favorabil' | 'nefavorabil';
  } | null;
  created_at: string;
  updated_at: string | null;
  model: string | null;
};

// Symbol-specific data including price change
export type SymbolData = {
  symbol: string;
  price_change_percent: string;
  prediction_json: LlmDetection['prediction_json'];
};

// Define the ArticleWithDetections type
export type ArticleWithDetections = Article & {
  detections: LlmDetection[];
};

// Define the enhanced article type with multiple symbols
export type NewsArticle = ArticleWithDetections & {
  symbols: SymbolData[];
};
